import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
// import { useQuery } from "@tanstack/react-query";
import { getVisits } from "../api";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { format, parse, startOfWeek, getDay } from "date-fns";


import { usePatientQueue } from "../hooks/usePatientQueue.js";
import PatientQueue from "../components/PatientQueue.jsx";
import VideoRoom from "../components/VideoRoom.jsx";
import DashboardTabs from "../components/DashboardTabs.js";

import { useAppContext } from "../AppContext.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faCalendarDays,
  faCalendarCheck,
  faCalendarPlus,
  faUserDoctor,
  faHospital,
  faVideo,
  faPerson,
  faEye,
  faCross,
  faCancel
} from "@fortawesome/free-solid-svg-icons";

import moment from "moment";

import CONFIG from './../config.js';

import useService from './../services';

const locales = { "en-US": require("date-fns/locale/en-US") };
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});



function VisitQueuePage({ onLogout }) {
  const navigate = useNavigate();
    //const { invokeLambda } = useService();
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [viewMode, setViewMode] = useState("list"); // NEW toggle
  const [calendarView, setCalendarView] = useState("week"); // NEW calendar view
 const { setUser, setIsAuthenticated, state, setState, setPatientInfo, setDoctorInfo } = useAppContext();
  const {
    sessions,
    activeSession,
    callStatus,
    queueError,
    callError,
    admitPatient,
    endCall,
    forceEndSession,
    refreshQueue,
  } = usePatientQueue();

  useEffect(() => {
    console.log("Fetching visits...",state);

    loadAppointments();
  }, [state?.providerId]);


  async function loadAppointments() {
  
  try {
    const pid = state?.providerId;
   
    const r = await getAppointments(); // await invokeLambda(CONFIG.lambdaAppointment, { action:"list", patient_id:pid });
    console.log("Fetched appointments:", r);
    //const appts = r && r.appointments ? r.appointments : [];
    setSelectedFilter(r);
  } catch(err) {
    console.error("Error fetching appointments:", err);
  }
}

 async function getAppointments() {

    let url = CONFIG.apiEndpoint + '/provider/appointments';

    //url += `/${encodeURIComponent(state?.providerId)}`;

    const response = await fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${state?.accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  const navReviewpage = (appointmentObj) => {

    console.log("Navigating to review page:", appointmentObj);
    navigate("/review", {
      state: {
        appointment: appointmentObj,
      },
    })
  }

 
  const handleTabChange = (tab) => {
    console.log("Selected tab:", tab);

    if (tab === "visits") {
      // Load visits

      navigate('/doctor-dashboard');
    }

    if (tab === "conference") {
      // Load conference
      navigate('/doctor-vqueue');
    }
  };



  return (<div className='container' >
    <div style={{ marginTop: '0px', paddingTop: '0px' }} >
      {/* <DashboardTabs onTabChange={handleTabChange} name={'visits'} /> */}



      <div className="">

        <div>
          <h3 className="queue-title my-4">
            Visits{" "}
            <span className="text-small">({selectedFilter?.length})</span>
          </h3>
        </div>

        <div className="queue-list" style={{ height: '600px', maxHeight: '600px' }} >
          {selectedFilter?.map((visit) => (
            <div
              className="queue-item"
              key={`${visit.id}`}
            >
              <div>
                <div className="visit-meta">
                  <div className="fw-bold fs-6 mb-2">
                    {visit.provider_name || "Not Available"}
                  </div>

                  <div className="d-flex flex-column flex-md-row gap-3">
                    <div>
                      <FontAwesomeIcon
                        icon={faCalendarDays}
                        className="me-2 text-primary"
                      />
                      Start Date:{" "}
                      {visit.created_at
                        ? moment(visit.created_at).format("MM-DD-YYYY HH:mm")
                        : ""}
                    </div>

                    <div>
                      <FontAwesomeIcon
                        icon={faUserDoctor}
                        className="me-2 text-primary"
                      />
                      {visit.provider_name || "Not Available"}
                    </div>

                    <div>
                      <FontAwesomeIcon
                        icon={faHospital}
                        className="me-2 text-primary"
                      />
                      {visit.reason_for_visit || "Not Available"}
                    </div>

                    <div>
                      {visit.visit_type?.toLowerCase() === "in-person" ? (
                        <span>
                          <FontAwesomeIcon icon={faPerson} className="mx-2 text-primary" />{visit.visit_type?.toLowerCase()}</span>
                      ) : (<span>
                        <FontAwesomeIcon icon={faVideo} className="mx-2 text-primary" />
                        {visit.visit_type?.toLowerCase()}
                      </span>
                      )}
                    </div>
                  </div>
                </div>

              </div>
              <div className="queue-item-status">
                <span
                  className={`wf-badge ${visit.appointment_status === "BOOKED" ? "pending" : "approved"}`}
                >
                  {visit.appointment_status}
                </span>
                {/* <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => doCancelAppointment(visit)}
                >
                  <FontAwesomeIcon icon={faCancel} className="text-danger" />
                  Cancel
                </button> */}
                <button
                  className="btn btn-sm btn-outline-success"
                  onClick={() => navReviewpage(visit)}
                >
                  <FontAwesomeIcon icon={faEye} className="text-success" />
                  Review
                </button>
              </div>
            </div>
          ))}
        </div>

      </div>



    </div></div>
  );
}

export default VisitQueuePage;
